/*!

=========================================================
* Vue Argon Design System - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system/blob/master/LICENSE.md)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import axiosRetry from "axios-retry";
import VueAxios from "vue-axios";
import { createHead } from "@vueuse/head";
import {createBootstrap} from 'bootstrap-vue-next/plugins/createBootstrap'
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';
import Argon from "./plugins/argon-kit";
import Paginate from 'vuejs-paginate-next';
import './registerServiceWorker';
import './assets/vendor/espace-icon-sns/icon-sns.css';

// すべてのBootstrap Vue Nextコンポーネントをインポート
import * as BvnComponents from 'bootstrap-vue-next/components'

axiosRetry(axios, { retries: 3 });

const app = createApp(App);
const head = createHead();

app.use(router);
app.use(head);
app.use(VueAxios, axios);
app.use(createBootstrap());
app.use(Argon);
app.component('paginate', Paginate);

// すべてのBootstrap Vue Nextコンポーネントをグローバル登録
Object.entries(BvnComponents).forEach(([componentName, component]) => {
  if (componentName.startsWith('B')) { // Bで始まるコンポーネントのみ
    app.component(componentName, component);
  }
});

app.mount("#app");
